module.exports = __webpack_public_path__ + "static/media/PODCAST-COUNT-2.6c2f142e.png";